import * as types from '../actions/types';

const initialState = {
   toggler:false
}

export default function SidebarManagementReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.MANAGEMENT_TOGLE_SIDEBAR:
            return {
                toggler:action.payload,
            } 
        default:
            return state
    }
}
